module.exports = __webpack_public_path__ + "img/3.ca82cb3b.jpg";